import styles from './Swatch.module.css'

/* Colour dot for legends; the colour is data, so it is the one place an
   inline style is legitimate. */
export function Swatch({ color, label }: { color: string; label?: string }) {
  return <span className={styles.swatch} style={{ background: color }} role={label ? 'img' : undefined} aria-label={label} />
}
